import React, {useContext} from "react"
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Tag from "@amzn/meridian/tag"
import Text from "@amzn/meridian/text"
import RadioButton from "@amzn/meridian/radio-button"
import {RouteFilterContext} from "./context/RouteFilterContext";
import {injectIntl} from "react-intl";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const RouteViewFilter = ({intl}) => {

    const {viewModelRouteFilter, dispatchRouteFilter} = useContext(RouteFilterContext)
    const {headerFont} = useDeviceLayout()

    return (
        <Column spacingInset="none">
            <Row width="100%" spacingInset="medium large" backgroundColor="secondary">
                <b>
                    <Text type={headerFont}> {intl.formatMessage({id: 'route.routes'})}: </Text>
                </b>
                <Row>
                    {viewModelRouteFilter.allRouteType.map(routeType => {
                        return <RadioButton key={routeType}
                            checked={viewModelRouteFilter.selectedRouteType[0] === routeType}
                            onChange={(data) => dispatchRouteFilter({type: 'SELECT_ROUTE_TYPE', routeType: data})}
                            value={routeType}>{routeType}</RadioButton>
                    })}
                </Row>
            </Row>
            <Row width="100%">
                <div className="filter-tag">
                    {viewModelRouteFilter.selectedRouteType.map(routeType => {
                        return <Tag key={routeType} type="theme">{routeType}</Tag>
                    })}
                </div>
            </Row>
        </Column>
    )
}

export default injectIntl(RouteViewFilter)


// WEBPACK FOOTER //
// ./src/components/routeView/RouteViewFilter.js